<template>
	<div class="texing">
		<div class="lh-culture-bg img" style="background-image:url(img/a7.jpg);"></div>
    	<div class="logo img"><img src="img/uniqueness/logo.png"></div>
    	<div class="lh-uniq-jiu"><img src="img/uniqueness/jp.png"></div>
    	<Footer :footerData="footerData"></Footer>
	</div>
</template>
<script type="text/javascript">
	import Footer from '@/components/Footer'
	//import {mapState} from 'vuex'
	export default{
		data(){
			return {
				footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:11,type:'culture'},
				on:''
			}
		},
		components:{
			Footer
		},
		computed:{
	      //...mapState(['username','count'])
	    },
	    mounted(e){
	    	
	    },
	    created(e){
	    	var that=this;
	    	setTimeout(function(){
	            that.footerData={audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:11,type:'culture',progress:true};
	    				var tips='<div class="lh-end"><h3>消息<i class="iconfont icon-l-close tip-close"></i></h3><div class="cont">当前课件已学习完成，请学习下一个课件。</div><a href="javascript:;" id="Back">确定</a></div>';
	    				if($('.lh-end').length<=0){
	    					$('#app').append(tips);
	    				}
	    			},5000);
	    			$(document).on('click','.tip-close',function(){
	    				$('.lh-end').remove();
	    			});
	    			//结束后返回
	          document.addEventListener('UniAppJSBridgeReady', function () {  
	          	  //自定义点击事件
	              $(document).on('click','#Back', function (evt) {  
	                console.log("aa")  
	               	uni.navigateBack({})
	              });  
	          });
	    },
		methods:{
			playMusic(e){
			var that=this,music = 'img/audio/01.mp3',text = that.$store.state.logoText;
			if(text){
					that.footerData.audioData.text=text;
				}
			if(music){
				var audio = $('#audio')[0];
				audio.src=music;
				audio.play();
				//that.playSetFooterData({icon:"icon-zanting"});
				that.footerData.audioData.icon="icon-zanting";
				//输出总时间
				audio.addEventListener('loadedmetadata',function(e){
					var duration = s_to_hs(Math.floor(audio.duration));
					//that.playSetFooterData({total:duration});
					that.footerData.audioData.total=duration;
				});
				//输出当前播放时间
				audio.addEventListener('timeupdate',function(e){
					var currentTime = audio.currentTime;
					var currentTime1=audio.currentTime.toFixed(2);
					//var currentTime=(this.currentTime/60).toFixed(2).toString().replace(/\./g,":");
					var currentTime=s_to_hs(Math.floor(currentTime));
					that.footerData.audioData.current=currentTime;
					var duration = audio.duration;
					var percentage = 100 * currentTime1/duration;
					//that.playSetFooterData({percentage:percentage});
					that.footerData.audioData.percentage=percentage;
				});
				function s_to_hs(s){
				    //计算分钟
				    //算法：将秒数除以60，然后下舍入，既得到分钟数
				    var h;
				    h  =   Math.floor((s/60));
				    //计算秒
				    //算法：取得秒%60的余数，既得到秒数
				    s  =   s%60;
				    //将变量转换为字符串
				    h    +=    '';
				    s    +=    '';
				    //如果只有一位数，前面增加一个0
				    h  =   (h.length==1)?'0'+h:h;
				    s  =   (s.length==1)?'0'+s:s;
				    return h+':'+s;
				}
				//播放完成
				audio.addEventListener('ended',function(e){
					//that.playSetFooterData({icon:"icon-bofang"});
					that.footerData.audioData.icon="icon-bofang";
					that.jx="on";	
				});
			}
		}
		}
	}
</script>